export const STORIES_WIDGET_LOCAL_STORAGE_KEY = 'storycollapsed';
export const STORIES_CREATE_PROMO_LOCAL_STORAGE_KEY = 'storycreatepromo';
